/**
 * Attar product card sheet — size pick + direct add.
 * Toast confirmation + temporary ✓ on the "+" trigger.
 * Guarded so multiple <script> tags never register listeners twice.
 */
(function () {
  if (window.AttarProductCardSheet) return;
  window.AttarProductCardSheet = true;

  var PLUS_SVG =
    '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var CHECK_SVG =
    '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5,13 10,18 19,7"/></svg>';

  var pendingTrigger = null;
  var pendingMeta = null;
  var toastLockUntil = 0;
  var pendingSheet = null;

  function setSheetLoading(sheet, option, isLoading) {
    if (!sheet) return;

    if (isLoading) {
      pendingSheet = sheet;
      sheet.classList.add('is-adding');
      sheet.querySelectorAll('.pcs-option, .size-sheet-option').forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'false');
      });
      if (option) {
        option.classList.add('pcs-option--loading');
        option.setAttribute('aria-busy', 'true');
      }
      return;
    }

    sheet.classList.remove('is-adding');
    sheet.querySelectorAll('.pcs-option, .size-sheet-option').forEach(function (btn) {
      btn.classList.remove('pcs-option--loading');
      btn.removeAttribute('aria-busy');
      if (btn.getAttribute('data-available') === 'true') {
        btn.disabled = false;
      }
    });
    if (pendingSheet === sheet) pendingSheet = null;
  }

  function clearPendingLoading() {
    if (pendingSheet) setSheetLoading(pendingSheet, null, false);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function ensureToastStack() {
    var stack = document.getElementById('attar-toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.id = 'attar-toast-stack';
      stack.className = 'attar-toast-stack';
      stack.setAttribute('aria-live', 'polite');
      stack.setAttribute('aria-atomic', 'true');
      document.body.appendChild(stack);
    }
    return stack;
  }

  function showToast(messageHtml) {
    var now = Date.now();
    if (now < toastLockUntil) return;
    toastLockUntil = now + 1500;

    var stack = ensureToastStack();
    // One toast at a time
    stack.innerHTML = '';

    var toast = document.createElement('div');
    toast.className = 'attar-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = messageHtml;
    stack.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.classList.add('is-leaving');
      setTimeout(function () {
        if (toast.parentNode) toast.remove();
      }, 280);
    }, 2400);
  }

  function closeOpenSheets() {
    document.querySelectorAll('drawer-component.product-card-sheet[open]').forEach(function (sheet) {
      if (typeof sheet.hide === 'function') sheet.hide();
    });
    document.body.classList.remove('product-sheet-open');
  }

  document.addEventListener('drawer:handleAfterShow', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('product-card-sheet')) {
      document.body.classList.add('product-sheet-open');
    }
  });

  document.addEventListener('drawer:handleAfterHide', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('product-card-sheet')) {
      document.body.classList.remove('product-sheet-open');
      if (event.target === pendingSheet || event.target.classList.contains('is-adding')) {
        setSheetLoading(event.target, null, false);
      }
    }
  });

  function markTriggerAdded(btn) {
    if (!btn) return;
    // Collection "+" buttons swap to a check; list/cart ATC keeps its icon.
    if (!btn.classList.contains('add-btn')) {
      btn.classList.add('added', 'bump');
      setTimeout(function () {
        btn.classList.remove('added', 'bump');
      }, 900);
      return;
    }
    btn.classList.add('added', 'bump');
    btn.innerHTML = CHECK_SVG;
    setTimeout(function () {
      btn.classList.remove('added', 'bump');
      btn.innerHTML = PLUS_SVG;
    }, 900);
  }

  function metaFromCard(card, extra) {
    extra = extra || {};
    if (!card) return extra;
    return {
      ref: card.getAttribute('data-ref') || '',
      insp: card.getAttribute('data-insp') || '',
      ml: extra.ml || '',
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-add-trigger]');
      if (!trigger) return;
      pendingTrigger = trigger;
      pendingMeta = metaFromCard(trigger.closest('[data-product-card]'), {
        ml: trigger.getAttribute('data-ml') || '',
      });
    },
    true
  );

  document.addEventListener('click', function (event) {
    var option = event.target.closest('.pcs-option, .size-sheet-option');
    if (!option || option.disabled) return;

    var sheet = option.closest('.product-card-sheet');
    if (!sheet || sheet.classList.contains('is-adding')) return;

    event.preventDefault();
    event.stopPropagation();

    var form = option.closest('form');
    var input = form && form.querySelector('[data-sheet-variant-input]');
    var variantId = option.getAttribute('data-variant-id');
    var available = option.getAttribute('data-available') === 'true';
    if (!form || !input || !variantId || !available) return;

    input.value = variantId;
    input.removeAttribute('disabled');

    var ml = option.getAttribute('data-ml') || '';
    sheet.dataset.pendingMl = ml;

    if (!pendingMeta) pendingMeta = {};
    pendingMeta.ml = ml;
    pendingMeta.ref = pendingMeta.ref || sheet.getAttribute('data-sheet-ref') || '';
    pendingMeta.insp = pendingMeta.insp || sheet.getAttribute('data-sheet-insp') || '';

    setSheetLoading(sheet, option, true);

    var submit = form.querySelector('.pcs__native-submit, .product-card-sheet__native-submit');
    if (submit) {
      submit.click();
    } else if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });

  document.addEventListener('product-ajax:added', function () {
    // Ignore cart updates that didn't come from a product card action
    if (!pendingTrigger && !pendingMeta) return;

    var meta = pendingMeta || {};
    var ref = meta.ref || '';
    var insp = meta.insp || '';
    var sheet = pendingSheet || document.querySelector('drawer-component.product-card-sheet[open]');
    var ml = (sheet && sheet.dataset.pendingMl) || meta.ml || '';

    var label = escapeHtml(ref);
    if (insp) label += (label ? ' · ' : '') + 'Insp. by ' + escapeHtml(insp);
    if (ml && ml !== '0') label += (label ? ', ' : '') + escapeHtml(ml) + ' ml';

    var trigger = pendingTrigger;
    pendingTrigger = null;
    pendingMeta = null;

    showToast(label ? 'Ajouté — <b>' + label + '</b>' : 'Ajouté au panier');
    markTriggerAdded(trigger);
    clearPendingLoading();
    closeOpenSheets();
  });

  document.addEventListener('product-ajax:error', function () {
    clearPendingLoading();
  });
})();
